import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Two-part tour for the practitioner consultant feature.
// 1. consultant-nav-tour: triggers on /practitioner, highlights the nav item
// 2. consultant-chat-tour: triggers on /practitioner/consultant, shows page features

export const consultantNavTourConfig: TourConfig = {
    id: "consultant-nav-tour",
    page: "/practitioner",

    welcome: {
        title: "Meet Your Personal Consultant",
        description:
            "Your AI-powered consultation tool can answer questions about individual sessions, the arc of work with a client, or themes spanning your entire practice.",
        startButtonText: "Show Me",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "consultant-nav",
            targetSelector: "a[href='/practitioner/consultant']",
            title: "Consultant in Your Sidebar",
            content:
                "Access your personal consultant anytime from the sidebar. It's always here when you need to reflect on your work.",
            position: "right",
        },
    ],
};

export const consultantChatTourConfig: TourConfig = {
    id: "consultant-chat-tour",
    page: "/practitioner/consultant",

    welcome: {
        title: "Your Personal Consultant",
        description:
            "Ask questions about individual sessions, patterns across a client's journey, or themes spanning your entire practice.",
        startButtonText: "Show Me Around",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "consultant-description",
            targetSelector: "[data-tour-id='consultant-description']",
            title: "What You Can Ask",
            content:
                "Ask about individual sessions, patterns across a client's journey, or themes spanning your entire practice.",
            position: "bottom",
        },
        {
            id: "consultant-chat-input",
            targetSelector: "[data-tour-id='consultant-chat-input']",
            title: "Start a Conversation",
            content:
                "Type a question here to start a new consultation. Each conversation is saved so you can revisit it later.",
            position: "top",
        },
    ],
};
